import * as React from 'react';

import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import { Euro } from 'lucide-react';

import { cn } from '../../utils/cn';

const options = maskitoNumberOptionsGenerator({
  decimalZeroPadding: true,
  precision: 2,
  decimalSeparator: ',',
  min: 0,
});

const moneyFormatter = Intl.NumberFormat('pt-PT', {
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const InputCurrency = React.forwardRef(
  ({ className, type, highlight = false, ...props }, ref) => {
    const inputRef = useMaskito(options);

    const _change = props.onChange;

    function handleChange(realChangeFn, formattedValue) {
      const digits = formattedValue.replace(/\D/g, '');
      const realValue = Number(digits) / 100;
      realChangeFn(realValue);
    }

    const formatValue = (value) => {
      if (value === null || typeof value === 'undefined' || isNaN(value)) {
        return '';
      }
      // moneyFormatter.format(0) might produce "€ 0,00". We just want to show "0,00".
      // We also need to remove the currency symbol because it's already in the component UI.
      return moneyFormatter.format(value).replace(/[€\s]/g, '');
    };

    return (
      <div
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background',
          props.disabled ? 'opacity-40' : 'opacity-100',
          className,
        )}
      >
        <input
          {...props}
          className={cn(
            'h-full flex-1 bg-background text-sm placeholder:text-muted-foreground focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-40 dark:disabled:opacity-30',
          )}
          ref={inputRef}
          type="text"
          value={formatValue(props.value)}
          onChange={(ev) => {
            handleChange(_change, ev.target.value);
          }}
        />
        <div
          className={cn(
            highlight && 'text-card-foreground',
            'ml-2 flex h-full items-center [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
          )}
        >
          <Euro />
        </div>
      </div>
    );
  },
);
InputCurrency.displayName = 'InputCurrency';

export { InputCurrency };
